export default __webpack_public_path__ + "static/HelveticaNeue-CondensedBold-be2ac3ec21d6cc4a342984cd87acd14f.woff";